import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      class: "tw-icon",
      rel: "nofollow",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.twitterWindow && _ctx.twitterWindow(...args)))
    }, _hoisted_2)
  ]))
}